
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        value: {
            type: [Number, Boolean] as PropType<number | boolean>,
            default: false,
        },
        label: {
            type: String,
            default: null,
        },
        returnInteger: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const emitUpdate = () => {
            if (props.disabled) return
            const value = !props.value

            if (props.returnInteger) {
                emit('update:value', Number(value))
                emit('change', Number(value))
                return
            }

            emit('update:value', value)
            emit('change', value)
        }

        return { emitUpdate }
    },
})
